var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 3C7.3674 3 7.24022 3.05268 7.14644 3.14644C7.05268 3.24022 7 3.3674 7 3.5V26.5C7 26.776 7.224 27 7.5 27H24.5C24.6326 27 24.7598 26.9474 24.8536 26.8536C24.9474 26.7598 25 26.6326 25 26.5V12H19.5C18.5717 12 17.6815 11.6313 17.0251 10.9749C16.3687 10.3185 16 9.42826 16 8.5V3H7.5ZM19 4.12V8.5C19 8.776 19.224 9 19.5 9H23.88L19 4.12ZM4 3.5C4 1.568 5.568 0 7.5 0H17.672C18.6 0 19.49 0.368 20.146 1.026L26.974 7.854C27.632 8.51 28 9.4 28 10.328V26.5C28 27.4282 27.6312 28.3184 26.9748 28.9748C26.3184 29.6312 25.4282 30 24.5 30H7.5C6.57174 30 5.6815 29.6312 5.02512 28.9748C4.36874 28.3184 4 27.4282 4 26.5V3.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileSmall);
export default __webpack_public_path__ + "static/media/fileSmall.ebe08491.svg";
export { ForwardRef as ReactComponent };